import { TableRow, Button, Layout, ClickEvent, SlideoutDecorator, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutRateAdjustments } from "./autogen/AutogenLayoutRateAdjustments";
import { RateUtil } from "../RateUtil";
import { table } from "console";

export class RateAdjustments extends AutogenLayoutRateAdjustments {
    private _editable: boolean

    set editable(ableToEdit: boolean) {
        this._editable = ableToEdit;
    }

    get editable(): boolean {
        return this._editable
    }
    
    tableRateAdjustmentsOnRowDisplay(event: TableRowDisplayEvent) {
            const tableRow = event.getTableRow();
            RateUtil.syncLocationByType(tableRow);
            RateUtil.syncRate(tableRow);
    }
}
